<template>
    <div id="page-content-wrapper">
        <div style="display: flex; justify-content: center; clear: both; margin-top: 20px;">
            <h1 style="text-align: center;">Gene Association Analysis</h1>
        </div>

        <div style="font-size: 18px; text-align: center;">
            <a href="/#/results?id=29a208ca0f664163b6964a9a9853c9cd" >View Demo Results</a>
        </div>

        <el-row justify="center" type="flex">
            <el-col :span="23">
                <el-divider />
            </el-col>
        </el-row>

        <!-- 新增可折叠提示 -->
        <el-row>
            <el-col :span="22" :push="1">
                <el-card shadow="never" class="mb-3">
                    <div slot="header" style="display: flex; justify-content: space-between; cursor: pointer;" @click="showHelp = !showHelp">
                        <span style="font-size: 18px; font-weight: bold; color: #409EFF;">
                            <i class="el-icon-s-operation" style="margin-right: 8px;"></i>
                            Tooltip - Gene Analysis & Comparison (Replication)
                            <i :class="showHelp ? 'el-icon-arrow-down' : 'el-icon-arrow-right'" style="margin-left: 8px;"></i>
                        </span>
                        <el-tag type="primary" effect="dark">Click to View Tutorial</el-tag>
                    </div>
                    <div v-show="showHelp">
                        <el-alert 
                            v-for="(item, index) in helpContent"
                            :key="index"
                            :title="item"
                            :closable="false"
                            class="mb-2"
                            style="font-size: 16px; line-height: 1; padding: 5px 1px; background-color: #fff;"
                            effect="dark"
                        >
                            <template slot="title">
                                <span style="font-weight: 500; color: black;">
                                    <i class="el-icon-info" style="margin-right: 8px;"></i>
                                    {{ item }}
                                </span>
                            </template>
                        </el-alert>
                    </div>
                </el-card>
            </el-col>
        </el-row>

        <el-row>
            <el-col :span="22" :push="1">
                <el-card shadow="never" class="mb-3">
                    <!--button-->

                    <!-- <h3>{{ activeRNA }}</h3> -->
                    <!-- <br /> -->

                    <el-row>
                        <el-col :span="12" :push="6">
                            <el-steps :active="active" simple>
                                <el-step title="Step 1 (Prepare)" icon="el-icon-upload"></el-step>
                                <el-step title="Step 2 (Configure)" icon="el-icon-edit"></el-step>
                            </el-steps>
                        </el-col>
                    </el-row>
                    <br />

                    <!--文件-->
                    <el-row
                        :gutter="20"
                        v-show="active === 0"
                        class="mt-3"
                        style="margin-bottom: 20px"
                    >
                        <el-col :span="12">
                            <el-card shadow="never">
                                <div
                                    slot="header"
                                    style="display: flex; justify-content: space-between"
                                >
                                    <span>Choose File
                                        <a style="font-size: 16px;" href="https://www.geneasso.net/static/GeneAsso.gz" target="_blank">Download Example Data</a>
                                    </span>
                                    <el-tooltip content="Click 'Choose file' to select and upload your GWAS summary statistics file. Ensure it is in the correct format *.gz as specified by the GENEasso.">
                                        <i
                                            class="el-icon-question i-button"
                                        />
                                    </el-tooltip>
                                </div>
                                <el-upload
                                    ref="matrixUpload"
                                    action=""
                                    :on-change="handleUploadMatrix"
                                    :auto-upload="false"
                                    :show-file-list="false"
                                    style="width: 100%"
                                    accept=".gz"
                                >
                                    <el-input
                                        readonly
                                        :value="matrixFile.name || ''"
                                        placeholder="Select your GWAS Summary Statistics file in gz format."
                                        style="width: 100%"
                                    >
                                        <span slot="append">select file</span>
                                    </el-input>
                                </el-upload>
                                <el-progress v-if="uploadProgress" :percentage="uploadProgress"></el-progress>
                            </el-card>
                        </el-col>
                        <el-col :span="12">
                            <el-card shadow="never">
                                <div
                                    slot="header"
                                    style="display: flex; justify-content: space-between"
                                >
                                <span>Separator
                                        <span style="color: red;font-weight: bold; font-size: 15px;">(After uploading your GWAS data, the separator is automatically detected. If it is not correct, please adjust it manually.)</span>
                                    </span>
                                    <el-tooltip content="Select the appropriate separator that corresponds to the delimiter used in your data （*.gz） file (e.g., comma, semicolon, tab).">
                                        <i
                                            class="el-icon-question i-button"
                                        />
                                    </el-tooltip>
                                </div>
                                <el-select
                                class="custom-select"
                                    v-model="selectedSeparator"
                                    filterable
                                    allow-create
                                    placeholder="Choose the delimiter used in your file."
                                >
                                    <el-option value="," label="," />
                                    <el-option value="tab" label="tab" />
                                    <el-option value="space" label="space" />
                                </el-select>
                            </el-card>
                        </el-col>
                    </el-row>
                    <el-row type="flex" align="middle">
                        <el-col :span="2">
                            <el-button
                                v-if="active === 0"
                                type="primary"
                                plain
                                class="mt-3 mb-3 float-left"
                                @click="handleLoadData"
                                >Load data</el-button
                            >
                        </el-col>
                        <el-col :span="10" style="height: 100%;">
                            <span style="color: red; font-weight: bold; margin-top: 30px; font-size: 15px;">Identifiers are auto-filled once you click 'Load Data'; please verify them for accuracy.</span>
                        </el-col>
                    </el-row>
                    <br />
                    <h4 style="color: red; font-weight: bold; font-size: 15px;">Fields marked with an asterisk (*) are required; all others are optional.</h4>
                    <br />
                    <el-form
                        :rules="ruleForm"
                        :model="formData"
                        ref="oneMainForm"
                        label-width="200px"
                    >
                        <el-row v-show="active === 0">
                            <el-row class="mt-3">
                                <el-col :span="12">
                                    <el-form-item label="Email" prop="email">
                                        <span slot="label">
                                            Email
                                            <el-tooltip content="Enter your email to receive job updates and a results link. If not provided, remember to save your job ID or bookmark the results page.">
                                                <i class="el-icon-question i-button" />
                                            </el-tooltip>
                                        </span>
                                        <el-input
                                            style="width: 80%;"
                                            v-model="formData.email"
                                            placeholder="Enter your email to receive job updates and a results link. If not provided, remember to save your job ID or bookmark the results page."
                                        >
                                        </el-input>
                                    </el-form-item>
                                    <el-form-item label="rsID Identifier" prop="rsid">
                                        <el-select
                                        class="custom-select"
                                            v-model="formData.rsid"
                                            filterable
                                            allow-create
                                            placeholder="Select the column header for rsIDs."
                                        >
                                            <el-option
                                                v-for="item in columnList"
                                                :value="item"
                                                :label="item"
                                            />
                                        </el-select>
                                    </el-form-item>

                                    <el-form-item label="P-Value Identifier" prop="pvalue">
                                        <el-select
                                        class="custom-select"
                                            v-model="formData.pvalue"
                                            filterable
                                            allow-create
                                            placeholder="Pick the header for p-values."
                                        >
                                            <el-option
                                                v-for="item in columnList"
                                                :value="item"
                                                :label="item"
                                            />
                                        </el-select>
                                    </el-form-item>

                                    <el-form-item label="Beta Identifier" prop="beta">
                                        <el-select
                                        class="custom-select"
                                            v-model="formData.beta"
                                            filterable
                                            allow-create
                                            placeholder="Identify the column for Beta values."
                                        >
                                            <el-option
                                                v-for="item in columnList"
                                                :value="item"
                                                :label="item"
                                            />
                                        </el-select>
                                    </el-form-item>

                                    <el-form-item label="Sample Size" prop="sampleSize">
                                        <el-input-number
                                            style="width: 60%;"
                                            v-model="formData.sampleSize"
                                            placeholder="Input your sample size."
                                        >
                                        </el-input-number>
                                    </el-form-item>

                                    <el-form-item
                                        label="Non Effect Allele Identifier"
                                        prop="nonEffectAllele"
                                    >
                                        <el-select
                                        class="custom-select"
                                            v-model="formData.nonEffectAllele"
                                            filterable
                                            allow-create
                                            placeholder="If applicable, select the non-effect allele header. (Optional)"
                                        >
                                            <el-option
                                                v-for="item in columnList"
                                                :value="item"
                                                :label="item"
                                            />
                                        </el-select>
                                    </el-form-item>
                                </el-col>

                                <el-col :span="12">
                                    <el-form-item label="Pop" prop="pop">
                                        <el-select
                                        class="custom-select"
                                            v-model="formData.pop"
                                            filterable
                                            allow-create
                                            placeholder="Select the population reference. (Optional)"
                                        >
                                            <el-option value="EUR" label="European(EUR)" />
                                            <el-option value="EAS" label="East Asian (EAS)" />
                                            <el-option value="AFR" label="African (AFR)" />
                                            <el-option value="SAS" label="South Asian (SAS)" />
                                            <el-option value="AMR" label="Admixed American (AMR)" />
                                            <el-option value="Mixed" label="Mixed" />
                                        </el-select>
                                    </el-form-item>

                                    <el-form-item label="Chromosome Identifier" prop="chromosome">
                                        <el-select
                                        class="custom-select"
                                            v-model="formData.chromosome"
                                            filterable
                                            allow-create
                                            placeholder="Choose the header for chromosome numbers. (Optional)"
                                        >
                                            <el-option
                                                v-for="item in columnList"
                                                :value="item"
                                                :label="item"
                                            />
                                        </el-select>
                                    </el-form-item>

                                    <el-form-item
                                        label="Effect Allele Identifier"
                                        prop="effectAllele"
                                    >
                                        <el-select
                                        class="custom-select"
                                            v-model="formData.effectAllele"
                                            filterable
                                            allow-create
                                            placeholder="Select the effect allele column header. (Optional)"
                                        >
                                            <el-option
                                                v-for="item in columnList"
                                                :value="item"
                                                :label="item"
                                            />
                                        </el-select>
                                    </el-form-item>

                                    <el-form-item
                                        label="Genomic Position Identifier"
                                        prop="genomicPosition"
                                    >
                                        <el-select
                                        class="custom-select"
                                            v-model="formData.genomicPosition"
                                            filterable
                                            allow-create
                                            placeholder="Pick the genomic position header. (Optional)"
                                        >
                                            <el-option
                                                v-for="item in columnList"
                                                :value="item"
                                                :label="item"
                                            />
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-row>

                        <el-row v-show="active === 1">
                            <el-form-item label="Gene-Based Association Methods">
                                <el-checkbox-group
                                    v-model="formDataB.methodList"
                                    @change="handleCheckboxMethod"
                                >
                                    <el-checkbox :label="method" v-for="method in methodList">{{ method }}</el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>

                            <el-card
                                shadow="never"
                                :header="key == 'RWAS' ? 'RWAS Parameters(The RWAS calculation may take several hours, please be patient.): ' : key + ' Parameters: '"
                                v-for="key in Object.keys(tempParams)"
                                :key="key"
                                class="mb-3"
                            >
                                <el-form-item label="P" v-if="key == 'LDAK-GBAT'">
                                    <el-input-number :precision="2" :step="0.1" v-model="tempParams[key].p" placeholder="Set the p-value threshold for significance (default: 0.05)." />
                                </el-form-item>
                                <el-form-item label="Power" v-if="key == 'LDAK-GBAT'">
                                    <el-input-number :precision="2" :step="0.1" v-model="tempParams[key].power" placeholder="Enter the desired statistical power for the test (default: 0.25)." />
                                </el-form-item>
                                <el-form-item label="Gene Window" v-if="key == 'LDAK-GBAT'">
                                    <el-input-number :step="1" v-model="tempParams[key].geneWindow" placeholder="Specify the genomic range around the gene to be considered (default: 0)." />
                                </el-form-item>

                                <el-form-item label="P" v-if="key == 'PASCAL'">
                                    <el-input-number :precision="2" :step="0.1" v-model="tempParams[key].p" placeholder="Set the p-value threshold for significance (default: 0.05)." />
                                </el-form-item>

                                <el-form-item label="P" v-if="key == 'CWAS' || key == 'RWAS'">
                                    <el-input-number :precision="2" :step="0.1" v-model="tempParams[key].p" placeholder="Enter the significance level for your CWAS analysis (default: 0.05)." />
                                </el-form-item>
                                <el-form-item label="Tissue" v-if="key == 'CWAS'">
                                    <el-select
                                            v-model="tempParams[key].tissue"
                                            filterable
                                            placeholder="Select the target tissue from the dropdown for CWAS analysis. (default: Whole Blood)"
                                        >
                                        <el-option value="Whole Blood" label="Whole Blood" />
                                        <el-option value="Androgen" label="AR binding" />
                                        <el-option value="H3K27ac" label="H3K27ac" />
                                    </el-select>
                                </el-form-item>

                                <el-form-item label="Model" v-if="key == 'RWAS'">
                                    <el-select
                                            v-model="tempParams[key].model"
                                            filterable
                                            placeholder="Select the target model from the dropdown for RWAS analysis. (default: SUSIE)"
                                        >
                                        <el-option v-for="item in modelList" :value="item" :label="item" />
                                    </el-select>
                                </el-form-item>

                                <el-form-item label="Tissue" v-if="key == 'RWAS'">
                                    <el-select
                                            v-model="tempParams[key].tissue"
                                            filterable
                                            placeholder="Select the target tissue from the dropdown for RWAS analysis. (default: Pancancer)"
                                        >
                                        <el-option value="Pancancer" label="Pancancer" />
                                    </el-select>
                                </el-form-item>

                                <el-form-item label="P" v-if="key == 'TF-TWAS'">
                                    <el-input-number :precision="2" :step="0.1" v-model="tempParams[key].p" placeholder="Set your desired p-value cutoff for the TF-TWAS (default: 0.05)." />
                                </el-form-item>
                                <el-form-item label="Tissue" v-if="key == 'TF-TWAS'">
                                    <el-select
                                            v-model="tempParams[key].tissue"
                                            filterable
                                            placeholder="Choose the tissue to analyze from the dropdown menu (default: brain)."
                                        >
                                        <el-option value="Brain" label="Brain" />
                                        <el-option value="Breast" label="Breast" />
                                        <el-option value="Lung" label="Lung" />
                                        <el-option value="prostate" label="prostate" />
                                    </el-select>
                                </el-form-item>

                                <el-form-item label="P" v-if="key == 'FUSION-TWAS'">
                                    <el-input-number :precision="2" :step="0.1" v-model="tempParams[key].p" placeholder="Set your desired p-value cutoff for the TF-TWAS (default: 0.05)." />
                                </el-form-item>
                                <el-form-item label="Model" v-if="key == 'FUSION-TWAS'">
                                    <el-select
                                            v-model="tempParams[key].model"
                                            filterable
                                            placeholder="Please choose"
                                        >
                                        <el-option value="susie" label="SUSIE" />
                                        <el-option value="lasso" label="LASSO" />
                                        <el-option value="enet" label="ELAS NET" />
                                        <el-option value="top1" label="TOP1" />
                                        <el-option value="bestmodel" label="best-TWAS" />
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="Tissue" v-if="key == 'FUSION-TWAS'">
                                    <el-select
                                            v-model="tempParams[key].tissue"
                                            filterable
                                            placeholder="Choose the tissue to analyze from the dropdown menu (default: Whole Blood)."
                                        >
                                        <el-option :value="item" :label="item" v-for="item in tissueList" />
                                    </el-select>
                                </el-form-item>

                                <el-form-item label="P" v-if="key == 'MAGMA'">
                                    <el-input-number :precision="2" :step="0.1" v-model="tempParams[key].p" placeholder="Set the threshold p-value for MAGMA analysis (default: 0.05)." />
                                </el-form-item>
                                <el-form-item label="Gene Window" v-if="key == 'MAGMA'">
                                    <el-select
                                            v-model="tempParams[key].geneWindow"
                                            filterable
                                            placeholder="Choose the gene region boundary (e.g., 1Mbp for ±1 million base pairs from the gene, default: 0bp)."
                                        >
                                        <el-option value="0bp" label="0bp" />
                                        <el-option value="1Mbp" label="1Mbp" />
                                    </el-select>
                                </el-form-item>

                                <el-form-item label="P" v-if="key == 'DEPICT'">
                                    <el-input-number :precision="2" :step="0.1" v-model="tempParams[key].p" placeholder="Input the significance level p-value for DEPICT (default: 0.05)." />
                                </el-form-item>

                                <el-form-item label="P" v-if="key == 'SMR'">
                                    <el-input-number :precision="2" :step="0.1" v-model="tempParams[key].p" placeholder="Specify the p-value cutoff for SMR tests (default: 0.05)." />
                                </el-form-item>
                                <el-form-item label="eQTL Database" v-if="key == 'SMR'">
                                    <el-select
                                            v-model="tempParams[key].eQTLDatabase"
                                            filterable
                                            placeholder="Select the eQTL database for expression reference (default: GTEx)."
                                            @change="handleSMRTissuChange"
                                        >
                                        <el-option value="CAGE" label="CAGE" />
                                        <el-option value="Geuvadis" label="Geuvadis" />
                                        <el-option value="GTEx" label="GTEx" />
                                        <el-option value="PsychENCODE" label="PsychENCODE" />
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="Tissue" v-if="key == 'SMR' && tempParams[key].eQTLDatabase == 'GTEx'">
                                    <el-select
                                            v-model="tempParams[key].tissue"
                                            filterable
                                            placeholder="Choose the associated tissue for eQTL analysis from the dropdown (default: Whole Blood)."
                                        >
                                        <el-option :value="item" :label="item" v-for="item in tissueList" />
                                    </el-select>
                                </el-form-item>
                            </el-card>
                        </el-row>

                        <br />

                        <el-row class="mt-3">
                            <el-col class="text-center">
                                <el-button type="info" @click="handleStepPrev" v-if="active" key="Prev"
                                    >Prev</el-button
                                >
                                <el-button
                                    key="next"
                                    v-if="active === 0"
                                    type="info"
                                    @click="handleStepNext"
                                    :disabled="!isDataLoaded"
                                    >Next</el-button
                                >
                                <el-button type="success" color="#2a6240" @click="ok" v-if="active === 1" key="ok"
                                    >Submit</el-button
                                >
                            </el-col>
                        </el-row>
                    </el-form>
                </el-card>
            </el-col>
        </el-row>

    </div>
</template>

<script>

const buttonList = [
    { label: "miRNA", value: "" },
    { label: "mRNA", value: "" },
    { label: "tRNA", value: "" },
    { label: "Other", value: "" },
];

const checkboxMethodList = [
    { label: "LDAK-GBAT", value: "LDAK-GBAT" },
    { label: "PASCAL", value: "PASCAL" },
    { label: "CWAS", value: "CWAS" },
    { label: "RWAS", value: "RWAS" },
    { label: "TF-TWAS", value: "TF-TWAS" },
    { label: "FUSION-TWAS", value: "FUSION TWAS" },
    { label: "MAGMA", value: "MAGMA" },
    { label: "DEPICT", value: "DEPICT" },
    { label: "SMR", value: "SMR" },
];

const tissueList = [
"Whole Blood",
"Kidney Cortex",
"Small Intestine Terminal Ileum",
"Colon Transverse",
"Lung",
"Adipose Visceral Omentum",
"Stomach",
"Thyroid",
"Colon Sigmoid",
"Liver",
"Adrenal Gland",
"Adipose Subcutaneous",
"Heart Atrial Appendage",
"Heart Left Ventricle",
"Brain Caudate basal ganglia",
"Skin Sun Exposed Lower leg",
"Breast Mammary Tissue",
"Artery Aorta",
"Artery Tibial",
"Esophagus Gastroesophageal Junction",
"Nerve Tibial",
"Pancreas",
"Skin Not Sun Exposed Suprapubic",
"Pituitary",
"Brain Putamen basal ganglia",
"Minor Salivary Gland",
"Vagina",
"Artery Coronary",
"Brain Spinal cord cervical c-1",
"Muscle Skeletal",
"Brain Cerebellar Hemisphere",
"Brain Cerebellum",
"Brain Nucleus accumbens basal ganglia",
"Esophagus Muscularis",
"Uterus",
"Brain Substantia nigra",
"Prostate",
"Esophagus Mucosa",
"Spleen",
"Brain Amygdala",
"Brain Hippocampus",
"Brain Cortex",
"Brain Hypothalamus",
"Testis",
"Brain Frontal Cortex_BA9",
"Brain Anterior cingulate cortex BA24",
"Ovary"
]

const baseConfig = {
    method: "",
    numberOfPValueThreshold: "",
    windowSize: "",
    r2: "",
    bimFileId: "",
    famFileId: "",
    bedFileId: "",
    phenoFileId: "",
    bimFile: {},
    famFile: {},
    bedFile: {},
    phenoFile: {},
    bimFileProgress: 0,
    famFileProgress: 0,
    bedFileProgress: 0,
    phenoFileProgress: 0,
};

export default {
    name: "query",
    components: { },

    data() {
        return {
            activeBtn: "",
            matrixFile: {},
            annotationFile: {},
            checkboxMethods: [],
            buttonList,
            checkboxMethodList,
            activeRNA: "tRNA",
            active: 0,
            fileId: "",
            selectedSeparator: "",
            columnList: [],
            chocseItem: "",
            tissueList,
            isDataLoaded: false,
            methodList: ['LDAK-GBAT', 'PASCAL', 'CWAS', 'TF-TWAS', 'FUSION-TWAS', 'MAGMA', 'DEPICT', 'SMR', 'RWAS'],
            modelList: ['SUSIE', 'LASSO', 'ELASNET', 'TOP1', 'best-TWAS'],

            formData: {
                method: [],
            },
            // 验证规则
            ruleForm: {
                rsid: [{ required: true, message: "rsID Identifier not empty", trigger: "blur" }],
                beta: [{ required: true, message: "Beta Identifier not empty", trigger: "blur" }],
                pvalue: [
                    { required: true, message: "P-Value Identifier not empty", trigger: "blur" },
                ],
                // email: [{ required: true, message: "Email cannot be empty", trigger: "blur" }],
                sampleSize: [{ required: true, message: "Sample size Identifier not empty", trigger: "blur" }],
                ancestry: [{ required: true, message: "Ancestry not empty", trigger: "blur" }],
                includingUkbb: [
                    {
                        required: true,
                        message: "Including UKBB individuals not empty",
                        trigger: "blur",
                    },
                ],
                sexSpecific: [
                    { required: true, message: "Sex specific not empty", trigger: "blur" },
                ],
            },
            // 任务ID
            taskId: "",
            formDataB: {
                jobId: "",
                methodList: [],
                methodConfList: [],
            },
            tempParams: {},
            uploadProgress: 0,
            showHelp: false,
            helpContent: [
                "Step 1. Selecting Methods: You will see a list of gene-based association methods at the top of the page. These include LDAK-GBAT, RWAS, CWAS, TF-TWAS, FUSION-TWAS, MAGMA, DEPICT, and SMR. Choose the methods you wish to include in your analysis by clicking on the checkboxes next to each method name. A blue checkmark indicates that the method is selected.",
            "Step 2. Selecting Methods. For each selected method, configure the 'P' value thresholds, which typically start at 0.05. Use the '+' or '-' to adjust these values as needed for your analysis. Some methods may require additional parameters: TF-TWAS and FUSION-TWAS: Choose the relevant tissue from the dropdown menu for which the association will be analyzed. FUSION-TWAS: Select the model (e.g., LASSO) from the dropdown menu. MAGMA: Enter the gene window parameter that specifies the genomic range around the gene to be considered. DEPICT and SMR: Configure any additional options that are available, such as eQTL database selection.",
            "Step 3. Once all configurations are set, navigate to the bottom of the page and click the 'Submit' button. After submission, you will receive a job ID. This unique identifier is critical for tracking the progress and accessing the results of your analysis. Make sure to note this down or keep the email that you will receive containing the job ID.",
            "\"Results\" section of our analysis, the Manhattan Plot provides a visual representation of genetic associations across various chromosomes. This plot distinguishes between \"Personal\" findings from the user's uploaded GWAS summary statistics and \"Archival\" data from GENEasso's extensive resources with the same trait as selected by the user. Each point on the plot represents a gene, with its position reflecting its genomic location and its vertical height indicating the -log10 p-value, which signifies the strength of the association. Different colors denote different gene-based association methods, allowing for an immediate visual differentiation between the results of each method. By hovering over any dot, users can obtain detailed information about that gene's association, including the associated trait, statistical significance, and method used. The option to 'Enable Display Gene Label' allows users to view gene names directly on the plot, facilitating easy identification of regions of interest. This comprehensive tool is instrumental for researchers seeking to compare their results with previously established findings, offering critical insights for replication and validation efforts in research.",
            "\"Resource-Derived Significant Genes\" in the \"Results\" section refers to a curated collection of gene association data for various traits, meticulously compiled from an extensive array of previously collected GWAS summary statistics within the GENEasso resource. This dataset is crucial for replication efforts, as it allows researchers to confirm the consistency and reliability of their findings against a backdrop of established associations. The ability to compare current results with this resource-derived data is essential for reinforcing the validity of new discoveries and for enhancing the overall robustness of research."
            ],
        };
    },

    methods: {
        handleCheckboxMethod(list) {
            let obj = {};
            list.forEach((key) => {
                let conf = {
                    p: '0.05'
                }

                if (key == 'LDAK-GBAT') {
                    conf['power'] = 0.05
                } else if (key == 'CWAS') {
                    conf['tissue'] = 'Whole Blood'
                } else if (key == 'RWAS') {
                    conf['model'] = 'SUSIE'
                    conf['tissue'] = 'Pancancer'
                } else if (key == 'TF-TWAS') {
                    conf['tissue'] = 'Brain'
                } else if (key == 'FUSION-TWAS') {
                    conf['model'] = 'LASSO'
                    conf['tissue'] = 'Whole Blood'
                } else if (key == 'MAGMA') {
                    conf['geneWindow'] = '0bp'
                } else if (key == 'SMR') {
                    conf['eQTLDatabase'] = 'PsychENCODE'
                    conf['tissue'] = 'Whole Blood'
                }
                obj[key] = this.tempParams[key] || Object.assign(conf, baseConfig);
            });
            this.tempParams = obj;
        },

        handleSMRTissuChange(val) {
        },

        async handleStepNext() {
            await this.$refs.oneMainForm.validate();

            if (this.active === 0) {
                await this.handlePreCreateJob();
            }

            if (this.active < 1) this.active++;
        },

        async handleLoadData() {
            if (!this.matrixFile.raw) {
                this.$message({
                    message: "Please choose file",
                    type: "error",
                });
                return;
            }

            await this.ob_meta_parse();
            this.isDataLoaded = true;

            await this.parseConf();
        },

        // 最终上传文件
        async ok() {
            for (const key of Object.keys(this.tempParams)) {
                this.tempParams[key].method = key;
            }

            this.formDataB.methodConfList = Object.values(this.tempParams);

            const res = await this.$ajax.post("/job/twas/complete_create", this.formDataB);
            if (res.code === 200) {
                this.$message.success("Submit success");
                this.$router.push({
                    path: `/results`,
                    query: {
                        id: res.data
                    }
                })
            } else {
                this.$message.success(res.message);
            }
        },

        async handlePreCreateJob() {
            // 存储文件
            let data = {
                attachmentId: this.fileId,
                separator: this.selectedSeparator,
                conf: this.formData,
            };

            const res = await this.$ajax.post("/job/twas/pre_create", data);
            this.taskId = res.data;
            this.formDataB.jobId = this.taskId;
        },

        async ob_meta_parse() {
            const params = {
                attachmentId: this.fileId,
                separator: this.selectedSeparator,
            };

            const res = await this.$ajax.post("/job/meta/parse", params);
            this.columnList = res.data.columnList;
        },

        async getSeparator(attachmentId) {
            const params = {
                attachmentId,
            };

            const res = await this.$ajax.post("job/meta/separator", params);
            if (res.code !== 200) {
                this.$message.error(res.message);
                return;
            }
            this.selectedSeparator = res.data
        },

        async parseConf() {
            const params = {
                attachmentId: this.fileId,
                separator: this.selectedSeparator,
            };

            const res = await this.$ajax.post("job/meta/conf/parse", params);
            if (res.code !== 200) {
                this.$message.error(res.message);
                return;
            }
            this.formData = res.data
        },

        async uploadFile(file, callback) {
            const params = new FormData();
            params.append("file", file);
            console.log(callback)
            const res = await this.$ajax.upload("attachment/upload", params, {
                onUploadProgress: callback || ((progressEvent) => {
                    this.uploadProgress = Math.floor((progressEvent.loaded * 100) / progressEvent.total);
                }),
            });
            this.uploadProgress = 0;

            await this.getSeparator(res.data);

            return res.data;
        },

        handleStepPrev() {
            if (this.active > 0) this.active--;
        },

        async handleUploadMatrix(file) {
            this.$refs["matrixUpload"].clearFiles();
            this.matrixFile = file;

            this.fileId = await this.uploadFile(this.matrixFile.raw);

            this.isDataLoaded = false;
        },

        handleUploadAnnotation(file) {
            this.$refs["annotationUpload"].clearFiles();
            this.annotationFile = file;
        },

        // 全部重置
        handleResetForm() {},

        // method 全选
        handleSelectAllCheckboxMethod() {
            this.checkboxMethods = checkboxMethodList.map((v) => v.value);
        },
        // method 重置
        handleResetCheckboxMethod() {
            this.checkboxMethods = [];
        },

    },
};
</script>

<style lang="less" scoped>
.custom-select {
    width: 80%;
}

.checkbox-method {
    .el-checkbox {
        display: block;
    }
}

/deep/ .el-upload {
    width: 100%;
}

.required {
    color: red;
}
</style>
